/** Static product notice: it deliberately exposes no key, recovery, or mode control. */
export const PLAINTEXT_BACKUP_OWNER_NOTICE =
  "Yedekler ürün tarafından şifrelenmeden saklanır. Şifreleme ve saklama güvenliği sorumluluğu yedek sahibine aittir.";

export const backupCopy = Object.freeze({
  ownerNotice: PLAINTEXT_BACKUP_OWNER_NOTICE,
  restoreConfirmation: "Geri yükleme yalnızca yeni ve boş bir hedefe yapılır; işlem için yetkilendirme ve açık onay gerekir.",
});
